export class LineNumberFormat {
    allowFreeForm?: boolean;
    isDefault?: boolean;
    lineNumberFormatId?: string;
    name?: string;
    sections?: LineNumberFormatSection[];
    active?: boolean;
}

export class LineNumberFormatSection {
    lineNumberFormatSectionId?: string;
    index: number;
    name: string;
    type: LineNumberFormatSectionType;
    lineNumberFormatSectionTypeId?: string;
    allowAlpha: boolean;
    allowNumeric: boolean;
    minLength: number;
    maxLength: number;
    additionalChars: string;
    active?: boolean;
}

export class LineNumberFormatSectionType {
    lineNumberFormatSectionTypeId: string;
    index: number;
    name: string;
}
